import React, { useState } from "react";
import PaymentProviderList from "./PaymentProviderList";
import PaymentMethodList from "./PaymentMethodList";

const PaymentManager: React.FC = () => {
  const [section, setSection] = useState<"providers" | "methods">("providers");

  return (
    <div className="space-y-4">
      <div className="flex gap-2 mb-4">
        <button
          className={`px-4 py-2 rounded text-sm font-medium ${section === "providers" ? "bg-blue-600 text-white" : "bg-gray-100 text-gray-700 hover:bg-gray-200"}`}
          onClick={() => setSection("providers")}
        >
          Fornecedores
        </button>
        <button
          className={`px-4 py-2 rounded text-sm font-medium ${section === "methods" ? "bg-blue-600 text-white" : "bg-gray-100 text-gray-700 hover:bg-gray-200"}`}
          onClick={() => setSection("methods")}
        >
          Metodos de Pagamento
        </button>
      </div>

      {section === "providers" && <PaymentProviderList />}
      {section === "methods" && <PaymentMethodList />}
    </div>
  );
};

export default PaymentManager;
